import { EntCategory } from "./category";
import { EntTransportCategory } from "./transportCategory";

export class EntTypeTransport {
    id: number = 0;
    alias: string = "";
    nameRu: string = "";
    nameKy: string = "";
    category: EntCategory | null = null
    transportCategoryId: EntTransportCategory | null = null
}
